import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Actions
import { getFollowingGroups_Helper, getMyGroups_Helper, per, setSelectedGroup } from '../../actions/groupActions';

// Components - material UI
import { Button } from '@material-ui/core';

// Icons = material UI
import CheckIcon from '@material-ui/icons/Check';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import CategoryOutlinedIcon from '@material-ui/icons/CategoryOutlined';
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import SchoolOutlinedIcon from '@material-ui/icons/SchoolOutlined';
import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';
import FaceOutlinedIcon from '@material-ui/icons/FaceOutlined';
import WeekendOutlinedIcon from '@material-ui/icons/WeekendOutlined';

import CategoryData from '../../utils/categoryData/postCategories';
import Spinner from '../common/Spinner';
import GroupBlock_Mini from './GroupBlock_Mini';

const SelectGroups = ({ 
    closeModal, 
    showModal,
    auth: {
        user
    },
    group: {
        selected_group
    },
    setSelectedGroup
}) => {

    const [groupsData, setGroupsData] = useState([]);
    const [gotGroups, setGotGroups] = useState(false);
    const [groupsList, setGroupsList] = useState([]);

    useEffect(() => {

        if(showModal && !gotGroups) fetchMyGroups();
    }, [showModal]);

    useEffect(() => {

        renderGroupList();

    }, [groupsData, gotGroups, selected_group]);

    const fetchMyGroups = async () => {
        console.log('Fetching my groups')
        if(!user?.groups) {
            setGotGroups(true);
            return;
        }

        const followingGroupsList = await getFollowingGroups_Helper({ currentUser: user });
        const myGroupsList = await getMyGroups_Helper({ currentUser: user });
    
        setGroupsData([...followingGroupsList, ...myGroupsList]);
        setGotGroups(true);
    }

    const handleClick = (group_doc) => {
        console.log('group selected');

        // remove if selected group is already active
        if(selected_group?._id === group_doc?._id) {
            setSelectedGroup(null);
        } else {
            setSelectedGroup(group_doc);
            if(closeModal) closeModal();
        }
    }

    const renderGroupList = async () => {
        setGroupsList([]);

        if(!gotGroups) {
            setGroupsList([(
                <div className="no-rides small">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(groupsData.length > 0) {
                groupsData.map(group_doc => {
                    setGroupsList(groupsList => [...groupsList, (
                        <GroupBlock_Mini group_doc={group_doc} handleClick={handleClick} active={selected_group?._id === group_doc?._id} />
                    )])
                }) 
            } else {
                setGroupsList(userList => [...userList, (
                    <div className="no-rides small">
                        <h1>No groups found</h1>
                    </div>
                )])
                
            }
        } 
    }

    return (
        <div className="menu">
            {closeModal && (

                // Render close button if on full categoryPage for mobile
                <div style={{margin: '20px'}} onClick={closeModal} className="form__backBtn right">
                    <CloseOutlinedIcon />
                </div>
            )}

            {/* Header text */}
            <div className="menu-header">
                <div style={{fontWeight:'700', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                    <span>Select Group</span>
                </div>
                <div style={{color: 'rgb(83, 100, 113)', fontSize:'14px', fontWeight:'500', lineHeight:'20px', overflowWrap:'break-word'}}>
                    <span>Post in a group for better visibility.</span>
                </div>
            </div>

            {/* Category list */}
            <div className="menu-items-container">
                {groupsList}
            </div>
        </div>
    )
}

SelectGroups.propTypes = {
    auth: PropTypes.object.isRequired,  // Prop: Object representing authentication state
    setSelectedGroup: PropTypes.func.isRequired,
    group: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    auth: state.auth,  // Connect: Map authentication state from redux store to auth prop
    group: state.group,
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    setSelectedGroup
})(SelectGroups);
